/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTariffRegionZip.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/tariff-region-zip";

export class AutogenModelTariffRegionZip<RowType extends ModelRow> extends Endpoint<RowType, RowTariffRegionZipFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTariffRegionZip extends ModelRow<RowTariffRegionZipFields> {
	constructor(values?: Partial<RowTariffRegionZipFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTariffRegionZipFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	effective_timestamp: Date;
	exchange_point_plc_uid: number;
	expire_timestamp: Date;
	fd_zipcode: string;
	interline_assign_type_code: string;
	interline_plc_uid: number;
	reg_uid: number;
	rxz_type_code: string;
	rxz_uid: number;
	service_type_code: string;
	state_id: string;
}

